import React from "react";
import { TemplateComponentProps } from "../../containers/template_page/template_component/template_component";
import Dropdown, { Option } from "react-dropdown";
import { range } from 'lodash';
import PageProgressBar from "../../containers/template_page/page_progress_bar/page_progress_bar";
import { TFunction } from "i18next";
import { filterObj, toQueryString } from "../../utils/utils";
import { API_CONFIG } from "../../config/api_config";
import axios from "axios";
import { Col, Container, Row } from "react-bootstrap";
import TextSearchFilter from "../../common_components/text_search_filter/text_search_filter";
import ProfessorshipListItem, { ProfessorshipItem, professorshipKey } from "./c75_professorship_list_item";
import DoubleTemplateComponent
    from "../../containers/template_page/double_template_component/double_template_component";
import "./c75_professorship_search.scss";

const C75_CATTEDREONLINE_DATA_URLS = (language: string, params: { area?: string, keyword?: string }) => ({
    __data: `${API_CONFIG.BASE_URL}${API_CONFIG.PROFESSORSHIPS_PATH}/${language}?${toQueryString(params)}`,
    __other_data: [`${API_CONFIG.BASE_URL}${API_CONFIG.ACADEMIC_YEARS_PATH}`]
});
class C75ProfessorshipSearch extends DoubleTemplateComponent<ProfessorshipItem[]> {

    loadingRef = React.createRef<PageProgressBar>();

    constructor(props: TemplateComponentProps<any>) {
        super(props);

        // create date from 2015 to current year for year's filter
        const currYear = new Date().getFullYear();
        const yearsOptions = range(currYear - 4, currYear + 1)
            .reverse()
            .map(year => year + "/" + (year + 1));

        this.state = { search: "", year: (currYear) + "", yearsOptions: yearsOptions };

        this.requireInternationalization = true;
    };

    componentDidMount(): void {
        this.fetchUsingQueryParams();
    }

    /**
     * Fetch the data using the filters specified in the query parameters and update the state with the filters
     */
    fetchUsingQueryParams() {
        let params = filterObj(this.props.query, ["search", "year"]);

        if (params.search) {
            params.search = decodeURI(params.search);
        }


        if (!params.year) {
            params["year"] = this.state.yearsOptions[0].split("/")[0];
        }

        this.setState(params);

        let data = C75_CATTEDREONLINE_DATA_URLS(this.props.language, params);
        // if (!params.search) {
        //     data.__data = "";
        //     this.nextDataLoaded = true;
        //     this.setState({ data: [] }, () => this.onDataLoaded([]));
        // }
        this.doubleFetchWithData(data, false);
    }

    onOtherDataLoaded(index: number, data: any) {
        if (data) {
            let yearsOptions = data.map((year: any) => ({
                value: year.id_aa,
                label: year.desc
            })).reverse();
            this.setState({
                yearsOptions: yearsOptions
            });
        }
    }

    search = () => {
        // if (!this.state.search) {
        //     return;
        // }

        // Update the query string and the results

        this.setState({ loading: true }, () => {
            if (this.loadingRef && this.loadingRef.current) {
                this.loadingRef.current.reset();
            }
        });

        const url = `${API_CONFIG.BASE_URL}${API_CONFIG.PROFESSORSHIPS_PATH}/${this.props.language}`;

        let params: any = {
            search: this.state.search
        };

        if (this.state.year) {
            params["year"] = this.state.year;
        }

        this.updateQueryString(params);

        axios.get(url, { params: params }).then(res => {
            this.setState({
                data: res.data,
                loading: false
            });
        });
    };

    changeYear = (selected: Option) => {
        this.setState({
            year: selected.value
        }, () => this.search());
    };

    searchUpdated = (search: string) => {
        this.setState({ search: search }, () => this.search());
    };


    internationalComponentRender(data: ProfessorshipItem[], t: TFunction) {

        return (
            <div className="c75-professorship-search auto-margins">
                {this.state.loading && <PageProgressBar ref={this.loadingRef} speed={0.4} />}
                <Container fluid={true}>
                    <Row className="filters">
                        <Col xs={12} md={6}>
                            <TextSearchFilter placeholder={t("C75 search filter placeholder")}
                                value={this.state.search} searchUpdated={this.searchUpdated} />
                        </Col>
                        <Col xs={12} sm={6}>
                            <Dropdown
                                key="year-filter"
                                options={this.state.yearsOptions}
                                onChange={this.changeYear}
                                value={this.state.year} />
                        </Col>
                    </Row>
                    <Row className="scholarships">
                        {(data && !!data.length) ?
                            data.map((professorship: ProfessorshipItem) =>
                                <Col xs={12} key={"professorship-col-" + professorshipKey(professorship)}>
                                    <ProfessorshipListItem {...professorship} t={t} />
                                </Col>
                            )
                            :
                            (!this.state.loading && (this.state.search) ?
                                <div className="cards-no-result-text">{t("C75 no result") + this.state.search}</div>
                                :
                                <div className="cards-no-result-text">{t("C75 no filters")}</div>
                            )
                        }
                    </Row>
                </Container>
            </div>
        );
    }

}

export default C75ProfessorshipSearch;

